import type { ArtBoardMode } from './types'

// Modes the structure sidebar cannot coexist with. Most render their own panel
// in the same right-hand slot (SettingsSidebar and the Estimator); `gallery`
// takes over the whole canvas instead, and the panel would sit on top of the
// images. Either way, opening one closes the other.
export const ModesExclusiveWithStructure: ArtBoardMode[] = [
  'settings',
  'activity_history',
  'storage',
  'color',
  'symbol_library',
  'estimate',
  'readonly_estimate',
  'gallery',
]
